import { IconProps } from './types'

export const BackArrowIcon = ({ size, color }: IconProps) => {
  return (
    <svg
      width={size || '100%'}
      height={size || '100%'}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M10.1719 18.6914L4.10187 12.6214L10.1719 6.55141"
        stroke={color || 'currentColor'}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5898 12.6211L4.26984 12.6211"
        stroke={color || 'currentColor'}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1016 12.6211L17.6316 12.6211"
        stroke={color || 'currentColor'}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
